module.exports = __webpack_public_path__ + "img/map-pin-alt.53e68751.svg";